export default class MetaURL {
  host: string | any;
  hostname: string | any;
  origin: string | any;
  pathname: string | any;
  search: string | any;
  protocol: string | any;
  port: string | any;
  href: string | any;
  hash: string | any;
  referrer: string | undefined;
  
  constructor() {};
}